import type { CSSProperties } from 'react';

/** Общее оформление CRM-виджетов. */
export const crmWidgetStyle: CSSProperties = {
  background: '#fff',
  border: 'none',
};

export const crmWidgetAmountFormat = new Intl.NumberFormat('ru-RU', {
  maximumFractionDigits: 0,
});
